module.exports = __webpack_public_path__ + "officialStatic/img/new14.00577f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/new14.jpg
// module id = 4Iay
// module chunks = 0